// extracted by mini-css-extract-plugin
export var bodySections = "_7t-8";
export var gray = "_7t-7";
export var green = "_7t-4";
export var iconContainer = "_7t-9";
export var iconWidgetContainer = "_7t-1";
export var phoneIcon = "_7t-2";
export var red = "_7t-5";
export var statusDot = "_7t-3";
export var widgetContainer = "_7t-0";
export var yellow = "_7t-6";